"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolbarTableEditModal = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _button = require("../../button");

var _form = require("../../form");

var _layout = require("../../layout");

var _modal = require("../../modal");

var _screenReaderOnly = require("../../screen-reader-only");

var _text = require("../../text");

var _utils = require("../../utils");

var _constants = require("./constants");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ToolbarTableEditModal = function ToolbarTableEditModal(_ref) {
  var isOpen = _ref.isOpen,
      close = _ref.close,
      onClose = _ref.onClose,
      tableTitle = _ref.tableTitle,
      setReturnFocus = _ref.setReturnFocus,
      localization = _ref.localization,
      onSetTitle = _ref.onSetTitle;
  var inputRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(tableTitle),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      tableTitleValue = _useState2[0],
      setTableTitleValue = _useState2[1];

  var editModalId = (0, _react.useMemo)(function () {
    return (0, _utils.getUniqueId)('rte-edit-table-');
  }, []);
  var modalTitleTextId = "".concat(editModalId, "-title-text");
  var closeDialogTextId = "".concat(editModalId, "-close-text");

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      hasMissingAltTitleError = _useState4[0],
      setHasMissingAltTitleError = _useState4[1];

  var labelTexts = _objectSpread(_objectSpread({}, _constants.toolbarTableEditModalDefaultProps.localization), localization);

  var editTableTitleText = labelTexts.editTableTitleText,
      modalDescriptionText = labelTexts.modalDescriptionText,
      inputTitleText = labelTexts.inputTitleText,
      cancelButtonText = labelTexts.cancelButtonText,
      closeDialogAltText = labelTexts.closeDialogAltText,
      confirmButtonText = labelTexts.confirmButtonText,
      inputErrorAltTitleText = labelTexts.inputErrorAltTitleText;

  var onSubmit = function onSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    var titleNotSet = (tableTitleValue === null || tableTitleValue === void 0 ? void 0 : tableTitleValue.trim()) === '';
    setHasMissingAltTitleError(titleNotSet);

    if (onSetTitle !== undefined && tableTitleValue) {
      onSetTitle(tableTitleValue);
    }
  };

  var renderFooter = function renderFooter(_ref2) {
    var errorText = _ref2.errorText,
        footerProps = _ref2.footerProps,
        isError = _ref2.isError;

    if (isError) {
      return (0, _core.jsx)(_form.InputFooter, footerProps, (0, _core.jsx)(_form.InputFooterText, null, errorText));
    }

    return undefined;
  };

  (0, _react.useEffect)(function () {
    if (isOpen && inputRef.current || hasMissingAltTitleError && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen, hasMissingAltTitleError]);
  return (0, _core.jsx)(_modal.Modal, {
    setReturnFocus: setReturnFocus,
    "aria-labelledby": modalTitleTextId,
    close: close,
    onClose: onClose,
    isOpen: isOpen
  }, (0, _core.jsx)("form", {
    onSubmit: onSubmit,
    autoComplete: "off"
  }, (0, _core.jsx)(_form.FormWrapper, {
    width: _constants.TOOLBAR_MODAL_WIDTH,
    maxWidth: "100%"
  }, (0, _core.jsx)(_modal.ModalContent, {
    maxWidth: _constants.TOOLBAR_MODAL_WIDTH,
    titleTextId: modalTitleTextId,
    titleText: editTableTitleText,
    closeButtonAriaDescribedBy: closeDialogTextId,
    buttons: [(0, _core.jsx)(_button.Button, {
      key: "cancel-button",
      variant: _button.ButtonVariant.Tertiary,
      onClick: close,
      "aria-describedby": closeDialogTextId
    }, cancelButtonText), (0, _core.jsx)(_button.Button, {
      key: "confirm-button",
      variant: _button.ButtonVariant.Primary,
      type: "submit",
      "aria-describedby": closeDialogTextId
    }, confirmButtonText)]
  }, (0, _core.jsx)(_text.Text, {
    "margin-top": "0"
  }, modalDescriptionText), (0, _core.jsx)(_layout.Spacer, {
    height: "S400"
  }), (0, _core.jsx)(_form.InputWrapper, {
    id: "title-input",
    labelText: inputTitleText,
    required: true,
    error: hasMissingAltTitleError,
    footer: function footer(footerProps) {
      return renderFooter({
        footerProps: footerProps,
        isError: hasMissingAltTitleError,
        errorText: inputErrorAltTitleText
      });
    }
  }, function (inputProps) {
    return (0, _core.jsx)(_form.Input, (0, _extends2.default)({}, inputProps, {
      defaultValue: tableTitle,
      type: "text",
      onChange: function onChange(e) {
        return setTableTitleValue(e.target.value);
      },
      ref: inputRef
    }));
  }), (0, _core.jsx)(_screenReaderOnly.ScreenReaderOnly, {
    id: closeDialogTextId,
    hidden: true
  }, closeDialogAltText)))));
};

exports.ToolbarTableEditModal = ToolbarTableEditModal;